/**
 * 한영전환 시 날짜 표시 형식을 언어에 맞게 보여주는 날짜 입력 컴포넌트
 * - ko: YYYY년 MM월 DD일 (예: 2025년 03월 20일)
 * - en: MM/DD/YYYY (예: 03/20/2025)
 * 네이티브 input type="date"는 브라우저 로케일에만 반응하므로 react-datepicker 사용
 */
import React from 'react';
import { useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import ko from 'date-fns/locale/ko';
import enUS from 'date-fns/locale/en-US';

import 'react-datepicker/dist/react-datepicker.css';
import './LocaleDateInput.css';

registerLocale('ko', ko);
registerLocale('en', enUS);

const LocaleDateInput = ({
  value,
  onChange,
  minDate,
  maxDate,
  disabled,
  className = 'input_05',
  placeholderText,
  dateFormat,
  ...rest
}) => {
  const language = useSelector(state => state?.language?.language) || 'ko';
  const locale = language === 'ko' ? 'ko' : 'en';
  const format =
    dateFormat || (language === 'ko' ? 'yyyy년 MM월 dd일' : 'MM/dd/yyyy');

  const selectedDate = value ? new Date(value + 'T00:00:00') : null;
  const min = minDate ? new Date(minDate + 'T00:00:00') : undefined;
  const max = maxDate ? new Date(maxDate + 'T00:00:00') : undefined;

  const handleChange = date => {
    if (!date) {
      onChange?.('');
      return;
    }
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    onChange?.(`${y}-${m}-${d}`);
  };

  return (
    <DatePicker
      selected={selectedDate}
      onChange={handleChange}
      minDate={min}
      maxDate={max}
      disabled={disabled}
      locale={locale}
      dateFormat={format}
      placeholderText={placeholderText}
      className={className}
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      preventOpenOnFocus
      onKeyDown={e => e.preventDefault()}
      onKeyPress={e => e.preventDefault()}
      onPaste={e => e.preventDefault()}
      {...rest}
    />
  );
};

export default LocaleDateInput;
